
import { getRouteApi, linkOptions, Outlet } from "@tanstack/react-router";
import { TabNav } from "../components/tab-nav";
import { useRouterState } from "@tanstack/react-router";
import { medicalsNavigationItems } from "~/features/dashboard/data/navigation";
// import { MedicalsTopBanner } from "./components/medicals-top-banner";
// import { Button } from "~/features/appointments/components/calendar-button";
// import { Info } from "lucide-react";

export const medicalsLinkOptions = (program = 'weight-loss') => linkOptions({
  to: '/dashboard/medicals/$program',
  activeOptions: { exact: true },
  params: { program }
})

export function MedicalsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const routeApi = getRouteApi("/(dashboard)/dashboard/medicals/$program");
  const { program } = routeApi.useParams();

  const currentItem = medicalsNavigationItems?.find((item) => item.dynamicUrl?.(program) === pathname) ?? medicalsNavigationItems[0];

  return (
    <main className="flex flex-col gap-6">
      {/* <MedicalsTopBanner
      className="mb-2 relative w-[calc(100%+2rem)] left-[-1rem] bg-[#0404040D] flex items-center justify-center"
        title="Welcome to your Medicals Dashboard"
        subtitle="Here you can manage your medicals and medications"
        icon={
          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#4272DD]">
            <Info className="h-4 w-4 text-white" />
          </div>
        }
        actionButton={<Button>Get started</Button>}
        fullBleed
      /> */}
      <section className="py-4 sm:py-10">
        <TabNav
          isSupportPage={pathname.includes('support')}
          title={currentItem?.title ?? medicalsNavigationItems[0]?.title ?? 'Medicals'}
          description={currentItem?.description ?? medicalsNavigationItems[0]?.description ?? ""}
        />
        <Outlet />
      </section>
    </main>
  )
}

